module.exports = __webpack_public_path__ + "img/hybrid_power_bag.51583808.jpg";